'use strict';

angular
  .module('posApp')
  // TODO rename to swCurrency
  .filter('$currency', (numberFilter, settingsManager) => {
    let currencySymbol;

    return (val, noWhiteSpace) => {
      currencySymbol = settingsManager.settings.currency;

      switch (currencySymbol) {
        case undefined:
        case 'EUR':
          currencySymbol = '€';
          break;
        case 'USD':
          currencySymbol = '$';
          break;
        case 'GBP':
          currencySymbol = '£';
          break;
        case 'TRY':
          currencySymbol = '₺';
          break;
        case 'MAD':
          currencySymbol = 'Dhs';
          break;
      }

      /* Remove any added white space as this causes issues in some cases such
       * as exporting data to Excel
       */
      if (noWhiteSpace === 'noWhiteSpace') {
        return currencySymbol + numberFilter(val, 2);
      } else {
        return currencySymbol + '\u00A0' + numberFilter(val, 2);
      }
    };
  });
